declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
    __pv_fired__?: boolean
  }
}

let initialized = false

export function initFBPixel(): void {
  if (initialized || (window.fbq && window.fbq.loaded)) return

  const f = window as any
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', '26125121193820190')

  initialized = true
}

export function trackPageView(): void {
  if (!window.__pv_fired__) {
    window.__pv_fired__ = true
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(): void {
  window.fbq('track', 'AddToCart')
}
